// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconDeviceDesktop = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M54 10H10C8.76593 10 8 10.7659 8 12V44C8 45.2341 8.76593 46 10 46H26V50H18C16.7659 50 16 50.7659 16 52V54C16 55.2341 16.7659 56 18 56H46C47.2341 56 48 55.2341 48 54V52C48 50.7659 47.2341 50 46 50H38V46H54C55.2341 46 56 45.2341 56 44V12C56 10.7659 55.2341 10 54 10ZM50 30C50 31.2341 49.2341 32 48 32H46C44.7659 32 44 31.2341 44 30V28C44 26.7659 44.7659 26 46 26H48C49.2341 26 50 26.7659 50 28V30ZM50 20C50 21.2341 49.2341 22 48 22H46C44.7659 22 44 21.2341 44 20V18C44 16.7659 44.7659 16 46 16H48C49.2341 16 50 16.7659 50 18V20Z" />
    </svg>
  );
};
